export const Api = {
  common: {
    qiniu: 'auth/file/upToken',
    sm: 'web/nuth/sm'
  },
  user: {
    login: 'web/nuth/login',
    info: 'web/auth/user/info',
    update: 'web/auth/user/modify',
    reauth: 'web/nuth/user/reth',
    resetpwd: 'web/nuth/user/resetpwd'
  },
  sms: {
    sent: 'app/futh/sms/send'
  },
  doc: {
    list: 'web/futh/doc/7/plist',
    detail: 'web/futh/doc/detail'
  },
  captcha:{
    refresh: 'web/nuth/captcha/refresh',
    check: 'web/nuth/captcha/check'
  },

}
